'use strict';

var dom              = require('spa-dom'),
    prepareMovieData = require('./prepare.movie.data'),
    tag              = dom.tag;


/**
 * Change server data to list data.
 *
 * @param {Array} data - data for prepare
 *
 * @return {Array} ready data for LayoutList
 */
module.exports = function ( data ) {
    var result = [],
        $date, $focusWrapper, $blurWrapper,
        $backgroundFocus, $backgroundBlur;

    data.forEach(function ( item ) {
        item = prepareMovieData(item);
        $focusWrapper = tag('div', {className: 'focusWrapper'});
        $backgroundFocus = tag('div', {className: 'poster'});
        $focusWrapper.appendChild(tag('div', {className: 'container'}, $backgroundFocus));
        $date = tag('div', {className: 'movieTitle'});
        $focusWrapper.appendChild($date);

        $blurWrapper = tag('div', {className: 'blurWrapper'});
        $backgroundBlur = tag('div', {className: 'poster'});
        $blurWrapper.appendChild($backgroundBlur);

        item.name = item.name || item.original_name;

        item.poster = item.cover;
        if ( (item.censored || (item.category && item.category.censored)) && !core.accessControl.state ) {
            // $backgroundFocus.appendChild(tag('div', {className: 'name'}, item.name));
            $backgroundFocus.classList.add('censored');
            $backgroundBlur.appendChild(tag('div', {className: 'name'}, item.name));
            $backgroundBlur.classList.add('censored');
            item.cover = '';
        } else if ( !item.cover ) {
            $backgroundBlur.appendChild(tag('div', {className: 'name'}, item.name));
        }
        $date.innerText = item.name;

        $backgroundFocus.style.backgroundImage = item.cover;
        $backgroundBlur.style.backgroundImage = item.cover;

        result.push({
            items: [
                $focusWrapper,
                $blurWrapper
            ],
            value: item
        });
    });

    return result;
};
